export default __webpack_public_path__ + "media/9114fcc71d19ec350fdf50f556d2191316d43be980f6c2bccb9ba8022153e3a6.svg";